module.exports = __webpack_public_path__ + "static/media/teethFreespace.490d5ce2.svg";